import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import "./CreateSupplier.scss";
import Input from "../../../components/atoms/Input/Input";
import InputPassword from "../../../components/atoms/InputPassword/InputPassword";
import Button from "../../../components/atoms/Button/Button";
import { validateData } from "../../../utiles/ValidateEntries";
import { servicesSuppliers } from "../../../services/suppliers";
import ValidationMessage from "../../../components/atoms/ValidationMessage/ValidationMessage";
import { toast } from "sonner";
import FileUpload from "../../../components/atoms/FileUpload/FileUpload";

const SupplierForm = ({
    setClose,
    getSuppliers,
    supplierData = null,
    isEditMode = false,
}) => {
    const { id: groupId } = useParams(); // ID del grupo desde la URL

    const [newSupplier, setNewSupplier] = useState(
        supplierData || {
            name: "",
            // user: "",
            password: "",
            whatsapp: "",
            email: "",
            address: "",
            location: "",
            facebook: "",
            instagram: "",
            tiktok: "",
            website: "",
            businessHoursStart: "",
            businessHoursEnd: "",
            isActive: true,
            groupId: groupId,
        }
    );

    const [emptyField, setEmptyField] = useState({});
    // eslint-disable-next-line
    const [groups, setGroups] = useState([]);
    // eslint-disable-next-line
    const [loadingGroups, setLoadingGroups] = useState(true);
    const [imageFile, setImageFile] = useState(null);
    const [pdfFile, setPdfFile] = useState(null);

    // useEffect(() => {
    //     loadGroups();
    // }, []);

    // Procesar datos del proveedor en modo edición
    useEffect(() => {
        if (isEditMode && supplierData) {
            // Convertir formato de horas de "08:00:00" a "08:00" para inputs type="time"
            const processedData = {
                ...supplierData,
                businessHoursStart: supplierData.businessHoursStart
                    ? supplierData.businessHoursStart.substring(0, 5)
                    : "",
                businessHoursEnd: supplierData.businessHoursEnd
                    ? supplierData.businessHoursEnd.substring(0, 5)
                    : "",
                password: "", // Limpiar password en modo edición
                groupIds: supplierData.groupIds || (groupId ? [groupId] : []),
            };
            setNewSupplier(processedData);
        }
    }, [isEditMode, supplierData, groupId]);

    const eventChange = (e) => {
        const { name, value, type, checked } = e.target;

        setNewSupplier((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));

        setEmptyField((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Campos requeridos (password solo es requerido en modo crear)
        const requiredFields = isEditMode
            ? {
                  name: newSupplier.name,
                  //   user: newSupplier.user,
                  //   email: newSupplier.email,
                  whatsapp: newSupplier.whatsapp,
                  businessHoursStart: newSupplier.businessHoursStart,
                  businessHoursEnd: newSupplier.businessHoursEnd,
              }
            : {
                  name: newSupplier.name,
                  //   user: newSupplier.user,
                  password: newSupplier.password,
                  email: newSupplier.email,
                  whatsapp: newSupplier.whatsapp,
                  businessHoursStart: newSupplier.businessHoursStart,
                  businessHoursEnd: newSupplier.businessHoursEnd,
              };

        // Validación de datos requeridos
        const { status, emptyFields } = validateData(requiredFields);
        setEmptyField(emptyFields);

        if (!status) {
            toast.error("Por favor, completa todos los campos requeridos.");
            return;
        }

        const toastId = toast.loading(
            isEditMode ? "Actualizando proveedor..." : "Creando proveedor..."
        );

        try {
            // Crear FormData para enviar archivos
            const formData = new FormData();

            // Agregar campos de texto
            formData.append("name", newSupplier.name);
            // formData.append("user", newSupplier.user);
            formData.append("whatsapp", newSupplier.whatsapp);
            !isEditMode && formData.append("email", newSupplier.email);
            formData.append("address", newSupplier.address || "");
            formData.append("location", newSupplier.location || "");
            formData.append("facebook", newSupplier.facebook || "");
            formData.append("instagram", newSupplier.instagram || "");
            formData.append("tiktok", newSupplier.tiktok || "");
            formData.append("website", newSupplier.website || "");
            formData.append(
                "businessHoursStart",
                newSupplier.businessHoursStart
                    ? `${newSupplier.businessHoursStart}:00`
                    : ""
            );
            formData.append(
                "businessHoursEnd",
                newSupplier.businessHoursEnd
                    ? `${newSupplier.businessHoursEnd}:00`
                    : ""
            );
            formData.append("isActive", newSupplier.isActive);
            !isEditMode && formData.append("groupId", newSupplier.groupId);

            // Solo incluir password si tiene valor
            if (newSupplier.password && newSupplier.password.trim() !== "") {
                formData.append("password", newSupplier.password);
            }

            // Agregar archivos si existen
            if (imageFile) {
                formData.append("image", imageFile);
            }

            if (pdfFile) {
                formData.append("pdf", pdfFile);
            }

            const response = isEditMode
                ? await servicesSuppliers.updateSupplier(
                      supplierData.id,
                      formData
                  )
                : await servicesSuppliers.createSupplier(formData);

            const { success, message } = response;

            if (!success) {
                throw new Error(
                    message ||
                        `Error al ${
                            isEditMode ? "actualizar" : "crear"
                        } el proveedor`
                );
            }

            toast.success("Éxito", {
                description:
                    message ||
                    `Proveedor ${
                        isEditMode ? "actualizado" : "creado"
                    } correctamente`,
                icon: "🎉",
                duration: 5000,
                id: toastId,
            });

            // Recargar la lista de proveedores
            if (getSuppliers) {
                getSuppliers();
            }

            // Cerrar el modal después de 2 segundos
            setTimeout(() => setClose(false), 2000);
        } catch (error) {
            toast.error("¡Ups...!", {
                description: error.message,
                duration: 5000,
                icon: "😞",
                id: toastId,
            });
        }
    };

    return (
        <form className="create-supplier" onSubmit={handleSubmit}>
            {/* Información básica */}
            <div className="create-supplier__section">
                <FileUpload
                    variant="card"
                    accept="image/*"
                    onChange={(file) => setImageFile(file)}
                    label="Subir imagen del negocio"
                    maxSize={5}
                    initialFile={newSupplier.imageUrl}
                />

                <ValidationMessage show={emptyField.name}>
                    <Input
                        text={"Nombre del negocio *"}
                        name="name"
                        value={newSupplier.name}
                        show={emptyField.name}
                        onChange={eventChange}
                        placeholder="Ej: Carnicería El Buen Sabor"
                    />
                </ValidationMessage>

                {/* <ValidationMessage show={emptyField.user}>
                    <Input
                        text={"Usuario *"}
                        name="user"
                        value={newSupplier.user}
                        show={emptyField.user}
                        onChange={eventChange}
                        placeholder="Ej: juan.perez"
                    />
                </ValidationMessage> */}

                {!isEditMode && (
                    <ValidationMessage show={emptyField.password}>
                        <InputPassword
                            text={"Contraseña *"}
                            name="password"
                            value={newSupplier.password}
                            show={emptyField.password}
                            onChange={eventChange}
                            placeholder="Contraseña segura"
                        />
                    </ValidationMessage>
                )}

                {isEditMode && (
                    <ValidationMessage show={emptyField.password}>
                        <InputPassword
                            text={"Nueva Contraseña (opcional)"}
                            name="password"
                            value={newSupplier.password}
                            show={emptyField.password}
                            onChange={eventChange}
                            placeholder="Dejar vacío para mantener la actual"
                        />
                    </ValidationMessage>
                )}
            </div>

            {/* Información de contacto */}

            {!isEditMode && (
                <div className="create-supplier__section">
                    <ValidationMessage show={emptyField.email}>
                        <Input
                            text={"Email *"}
                            name="email"
                            type="email"
                            value={newSupplier.email}
                            show={emptyField.email}
                            onChange={eventChange}
                            placeholder="correo@ejemplo.com"
                        />
                    </ValidationMessage>

                    <ValidationMessage show={emptyField.whatsapp}>
                        <Input
                            text={"WhatsApp *"}
                            name="whatsapp"
                            value={newSupplier.whatsapp}
                            show={emptyField.whatsapp}
                            onChange={eventChange}
                            placeholder="1234567890"
                        />
                    </ValidationMessage>

                    <Input
                        text={"Dirección"}
                        name="address"
                        value={newSupplier.address}
                        onChange={eventChange}
                        placeholder="Calle Principal #123"
                    />

                    <Input
                        text={"Ubicación"}
                        name="location"
                        value={newSupplier.location}
                        onChange={eventChange}
                        placeholder="Ciudad, Estado"
                    />
                </div>
            )}

            {/* Redes sociales */}
            <div className="create-supplier__section">
                <Input
                    text={"Facebook"}
                    name="facebook"
                    value={newSupplier.facebook}
                    onChange={eventChange}
                    placeholder="facebook.com/tupagina"
                />

                <Input
                    text={"Instagram"}
                    name="instagram"
                    value={newSupplier.instagram}
                    onChange={eventChange}
                    placeholder="instagram.com/tupagina"
                />

                <Input
                    text={"TikTok"}
                    name="tiktok"
                    value={newSupplier.tiktok}
                    onChange={eventChange}
                    placeholder="tiktok.com/@tupagina"
                />

                <Input
                    text={"Sitio Web"}
                    name="website"
                    value={newSupplier.website}
                    onChange={eventChange}
                    placeholder="www.tusitio.com"
                />
            </div>

            {/* Horario de negocio */}
            <div className="create-supplier__section">
                <div className="create-supplier__time-container">
                    <ValidationMessage show={emptyField.businessHoursStart}>
                        <Input
                            text={"Hora de inicio *"}
                            name="businessHoursStart"
                            type="time"
                            value={newSupplier.businessHoursStart}
                            onChange={eventChange}
                            show={emptyField.businessHoursStart}
                        />
                    </ValidationMessage>

                    <ValidationMessage show={emptyField.businessHoursEnd}>
                        <Input
                            text={"Hora de cierre *"}
                            name="businessHoursEnd"
                            type="time"
                            value={newSupplier.businessHoursEnd}
                            onChange={eventChange}
                            show={emptyField.businessHoursEnd}
                        />
                    </ValidationMessage>
                </div>
                <div>
                    <FileUpload
                        variant="button"
                        accept=".pdf"
                        onChange={(file) => setPdfFile(file)}
                        label="Subir Documento PDF"
                        maxSize={10}
                        initialFile={newSupplier.pdfUrl}
                    />
                </div>
            </div>

            {/* Estado activo */}
            <div className="create-supplier__section">
                <label className="create-supplier__checkbox-label">
                    <input
                        type="checkbox"
                        name="isActive"
                        checked={newSupplier.isActive}
                        onChange={eventChange}
                        className="create-supplier__checkbox"
                    />
                    <span>Proveedor activo</span>
                </label>
            </div>

            <div className="create-supplier__form-actions">
                <Button
                    text={"Cancelar"}
                    type="button"
                    onClick={() => setClose(false)}
                />
                <Button
                    text={isEditMode ? "Actualizar" : "Guardar"}
                    className="degrad"
                    type="submit"
                />
            </div>
        </form>
    );
};

export default SupplierForm;
